export function trackConversion(
  event: string,
  params: Record<string, string> = {}
) {
  if (typeof window === 'undefined') return;
  const searchParams = new URLSearchParams({
    event,
    ts: Date.now().toString(),
    ...params,
  });

  const url = `/analytics/conv.gif?${searchParams.toString()}`;

  const img = new Image();
  img.src = url;
}
